import React from 'react';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import Tooltip from '../../../components/Tooltip';

const DeviceWarningAlert = ({ tooltipText, colorClass, ariaLabel, onOpen, children }) => {
  return (
    <>
      <Tooltip text={tooltipText} color={colorClass}>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onOpen?.();
          }}
          className="flex items-center justify-center cursor-pointer"
          aria-label={ariaLabel}>
          <ReportProblemOutlinedIcon className={colorClass} />
        </button>
      </Tooltip>
      {children}
    </>
  );
};

export default DeviceWarningAlert;
